import { CheckBox, Typography } from "components/atoms";

interface IProps {
  question: string | undefined;
  value: boolean;
  onChange: (e: any) => void;
}

export const AcknowledgeInput = ({ value, question, onChange }: IProps) => {
  return (
    <div className="acknowledge-wrapper">
      <CheckBox
        checked={value}
        onChange={() =>
          onChange(value === false || value === undefined ? true : false)
        }
      />
      {question ? (
        <Typography
          label={question}
          variant="h7Bold"
          styles="custom-acknowledge-question-style"
        />
      ) : null}
    </div>
  );
};
